<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-10">
                    <card>
                        <h4 slot="header" class="card-title"><span @click="goBack()" class="link">Назад</span> -
                            Общая информация</h4>
                        <form>
                            <div class="row">

                                <div class="loader" v-if="waiting"></div>

                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="premium-control"
                                               class="control-label label-checkbox">Премиум</label>
                                        <input v-model="image.is_premium" id="premium-control"
                                               class="form-check-inline" type="checkbox">
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Категория</label>
                                        <select v-model="image.category_id"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-for="c in categories" v-bind:value="c.id">
                                                {{ c.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Статус</label>
                                        <select v-model="image.status"
                                                id="status-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="1">Активен</option>
                                            <option value="0">Не активен</option>
                                        </select>
                                    </div>
                                    <fg-input type="text"
                                              label="Сортировка (чем больше, тем выше в списке)"
                                              v-model="image.sort"
                                              placeholder="">
                                    </fg-input>
                                </div>
                                <div class="col-md-3 buttons-block">
                                    <h4 slot="header" class="card-title">
                                        Фон: <span v-if="image.url">
                                                <a :href="image.url_full" target="_blank">(ссылка)</a></span>
                                    </h4>

                                    <div>
                                        <input ref="urlFileInput" class="btn-file" type="file"
                                               @change="uploadFile($event, 'url')">
                                        <button type="submit" class="btn btn-info btn-fill upload-button"
                                                @click="$refs.urlFileInput.click()">
                                            Загрузить
                                        </button>
                                        <div class="clearfix"></div>
                                    </div>

                                    <div class="device-block device1">
                                        <img :src="image.url_full">
                                    </div>
                                </div>

                                <div class="col-md-3 buttons-block">
                                    <h4 slot="header" class="card-title">
                                        Фон (превью): <span v-if="image.url_small">
                                        <a :href="image.url_small_full" target="_blank">(ссылка)</a>
                                        </span>
                                    </h4>

                                    <div>
                                        <input ref="urlSmallFileInput" class="btn-file" type="file"
                                               @change="uploadFile($event, 'url_small')">
                                        <button type="submit" class="btn btn-info btn-fill upload-button"
                                                @click="$refs.urlSmallFileInput.click()">
                                            Загрузить
                                        </button>
                                        <div class="clearfix"></div>
                                    </div>

                                    <div class="device-block device1">
                                        <img :src="image.url_small_full">
                                    </div>
                                </div>
                            </div>

                            <div class="text-center">
                                <button type="submit" class="btn btn-success btn-fill float-right btn-save"
                                        @click.prevent="save">
                                    Сохранить
                                </button>
                            </div>
                            <div class="clearfix"></div>
                        </form>
                    </card>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import Card from 'src/components/UIComponents/Cards/Card.vue'

    export default {
        name: 'CreateAlbum',
        components: {
            Card,
        },
        data() {
            return {
                id: null,
                token: localStorage.getItem('token'),
                waiting: false,
                image: {
                    status: 0,
                    category_id: null,
                    url: null,
                    url_full: null,
                    url_small: null,
                    url_small_full: null,
                    sort: 1,
                },
                categories: JSON.parse(localStorage.getItem('ii_categories')),
            }
        },
        created: function () {

        },
        methods: {
            goBack: function () {
                window.history.back();
            },
            save: function () {
                let self = this;

                let image = JSON.parse(JSON.stringify(this.image));

                self.waiting = true;

                axios.post(
                    `${this.$hostname}/admin/images/create`,
                    image,
                    {
                        'headers': {
                            'Authorization': 'Bearer ' + this.token
                        }
                    })
                    .then(function (response) {

                        const notification = {
                            template: `<span><b>Фон был успешно добавлен</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-explore-2',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'info'
                            })

                        self.waiting = false;

                        self.$router.push('/images');
                    })
                    .catch(function (error) {
                        const notification = {
                            template: `<span><b>${error.response.data.message}</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-simple-remove',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'danger'
                            })

                        self.waiting = false;

                    });
            },
            uploadFile: function (event, type) {
                let self = this;

                let formData = new FormData();

                self.waiting = true;

                formData.append('file', event.target.files[0]);

                axios.post(
                    `${this.$hostname}/admin/services/file/upload`,
                    formData,
                    {
                        params: {
                            file_type: type
                        },
                        headers: {
                            'Authorization': 'Bearer ' + this.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(function (response) {

                    self.waiting = false;

                    let data = JSON.parse(JSON.stringify(response.data));

                    self.image[`${type}`] = data.url;
                    self.image[`${type}_full`] = data.url_full;

                })
                    .catch(function (error) {
                        self.waiting = false;
                        console.log(error);
                    });
            },
        }
    }

</script>
<style scoped>
button:disabled,
button[disabled] {
    cursor: not-allowed;
}

.btn-save {
    width: 150px;
}

.buttons-block {
    padding-left: 20px !important;
}
.btn-info.btn-fill, .btn-info.btn-fill:active {
    color: #54abfe;
    background-color: #FFFFFF;
    border: 1px solid #54abfe;
    margin-top: 5px;
}
.checkbox-block {
    margin-top: 40px;
    margin-left: 40px;
}

.btn-file {
    display: none;
}

.image-block {
    max-width: 100%;
}

.form-check-inline {
    display: inline-block;
}

.label-checkbox {
    margin-right: 10px
}
.inline-link span {
    padding: 3px;
    border-radius: 4px;
    font-size: 18px;
}

.bg-danger {
    background-color: rgba(255, 70, 50, 0.5) !important;
}
.link {
    cursor: pointer;
    text-decoration: underline;
}

.card-body p {
    font-weight: 300;
    font-style: italic;
}

.card-body form {
    /*margin-top: 15px;*/
}

/* Customize the label (the container) */
.container {
    display: block;
    position: relative;
    padding-left: 30px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 12px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

/* Create a custom checkbox */
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #ccc;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
    opacity: 0.8;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
    background-color: #54abfe;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
    left: 8px;
    top: 4px;
    width: 5px;
    height: 10px;
    border: solid #fff;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}

.preview-device {
    display: inline-block;
    width: 32%;
    margin-left: 10px;
}


.device-block {
    position: relative;
    background-position: center center;
    background-size: cover;
    cursor: pointer;
    margin-top: 40px;
}


.device-block.inactive {
    opacity: 0.5;
}

.device-block img {
    max-width: 100%;
}

.device-block span {
    position: absolute;
    top: -30px;
    left: 5px;
}

.device1 {
    display: inline-block;
    /*width: 281px;*/
    /*height: 609px;*/
    width: 200px;
}

.mt30 {
    margin-top: 30px;
}

#ajaxForm, ajaxForm2, ajaxForm3 {
    position: relative;
}

.loader {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/static/img/oval.svg');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.7;
    filter: alpha(opacity=40);
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Image/Create.vue